import React from "react";
import PropTypes from "prop-types";

import styles from "./Card.module.css";
import classNames from "classnames";

export function Card({ title, children, className }) {
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.title}>{title}</div>

      <div className={styles.hr} />

      <div className={styles.content}>{children}</div>
    </div>
  );
}

Card.propTypes = {
  title: PropTypes.string,
};
